import { actionCreator } from '@ardoq/rxbeach';

export type SetHoveredItemPayload = string | null;
export const setHoveredItem = actionCreator<SetHoveredItemPayload>(
  '[Dependency Map] SET_HOVERED_ITEM'
);

export type SetFocusedItemPayload = string | null;
export const setFocusedItem = actionCreator<SetFocusedItemPayload>(
  '[Dependency Map] SET_FOCUSED_ITEM'
);
